if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      
           // --- BUNDLE LOGIC START (CORRECTED) ---
      const bundleDataInput = this.form.querySelector('[name="bundle-components-data"]');
      if (bundleDataInput && bundleDataInput.value) {
        try {
          const components = JSON.parse(bundleDataInput.value);
          
          // 1. Format each item with 'id' (must be the numeric Variant ID)
          const items = components.map(item => ({
            id: parseInt(item.variant_id), 
            quantity: parseInt(item.quantity || 1)
          }));

          // 2. Wrap in the mandatory 'items' top-level key
          const payload = {
            items: items
          };

          // 3. Include sections if using a Cart Drawer or Notification
          if (this.cart) {
            payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
            payload.sections_url = window.location.pathname;
            // The standard path below does this too; without it the notification
            // has nothing to hand focus back to when it closes.
            this.cart.setActiveElement(document.activeElement);
          }

          config.headers['Content-Type'] = 'application/json';
          config.body = JSON.stringify(payload);

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.handleErrorMessage(response.description || response.message);
                return;
              }
              // Standard success handling
              if (this.cart) {
                // A multi-item add returns {items:[…]} and nothing else, while a
                // single-item add returns the line itself, key and all. Dawn's
                // renderContents opens with `this.cartItemKey = parsedState.key`
                // and builds its first selector from it, so on a bundle it was
                // looking for [id="cart-notification-product-undefined"], getting
                // null back and throwing on .innerHTML — which meant open() was
                // never reached and no notification ever appeared. Verified
                // against /cart/add.js: the key is on items[0] in that shape.
                if (response.key === undefined && response.items && response.items.length) {
                  response.key = response.items[0].key;
                }

                this.cart.renderContents(response);
                publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
              } else {
                window.location = window.routes.cart_url;
              }
            })
            .catch((e) => console.error('Bundle Error:', e))
            .finally(() => {
              this.submitButton.classList.remove('loading');
              this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            });

          return; // Prevent standard single-item addition
        } catch (e) {
          console.error("Bundle JSON parsing failed:", e);
        }
      }
      // --- BUNDLE LOGIC END ---


      // Standard Dawn functionality for non-bundle products
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
